import {isGDriveSharedLink} from '@coolcolduk/google';
import {TextField} from '@mui/material';
import {HelpTutorialEnum} from '../../variables/helpTutorial';
import HelpButtonWrapper from '../helpButton/HelpButtonWrapper';

export interface TextFieldGoogleDriveLinkProps {
  sharedLink: string;
  setSharedLink: (sharedLink: string) => void;
}

export default function TextFieldGoogleDriveLink({sharedLink, setSharedLink}: TextFieldGoogleDriveLinkProps) {
  return (
    <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.GDRIVE_CREATE_SHARE_LINK}>
      <TextField
        fullWidth
        label="Google drive shared link"
        value={sharedLink}
        onChange={(e) => setSharedLink(e.target.value)}
        helperText="Share your google drive with shared -> anyone with link"
        error={!isGDriveSharedLink(sharedLink)}
      />
    </HelpButtonWrapper>
  );
}
